import Department from './Department';
import ParameterValue from './ParameterValue';
import Team from './Team';
import moment from 'moment';

export default class MemberRole {
    constructor() {
        this.id = null;
        this.notice = '';
        this.team = null;
        this.department = null;
        this.parameterValue = null;
        this.from = null;
        this.to = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const memberRole = new MemberRole();
        memberRole.id = data.id;
        memberRole.notice = data.notice;
        memberRole.from = data.from;
        memberRole.to = data.to;
        memberRole.isEditable = data.isEditable;
        memberRole.isDeletable = data.isDeletable;

        memberRole.department = Department.fromData((data.department.data));
        if (memberRole.department.id === null) {
            memberRole.department = null;
        }
        memberRole.team = Team.fromData(data.team.data);
        if (memberRole.team.id === null) {
            memberRole.team = null;
        }

        memberRole.parameterValue = ParameterValue.fromData(data.parameterValue.data);

        return memberRole;
    }

    getFromMomentObject() {
        return moment(this.from, 'DD.MM.YYYY');
    }

    getToMomentObject() {
        return moment(this.to, 'DD.MM.YYYY');
    }

    isEmpty() {
        return !this.parameterValue;
    }

    isValid() {
        if (!this.parameterValue) {
            return false;
        }

        if (this.from && this.to) {
            if (!this.isValidDateRange()) {
                return false;
            }
        }

        return true;
    }

    isValidDateRange() {
        if (!this.from) {
            return true;
        }
        if (!this.to) {
            return true;
        }

        return this.getToMomentObject() >= this.getFromMomentObject();
    }

    serialize() {
        return {
            fromDate: this.from,
            toDate: this.to,
            notice: this.notice,
            roleId: this.parameterValue.id,
            teamId: this.team ? this.team.id : null,
            departmentId: this.department ? this.department.id : null,
        };
    }

    equals(role) {
        if (role instanceof MemberRole) {
            return this.id === role.id;
        }
        return false;
    }

    overlaps(role) {
        if (role instanceof MemberRole) {
            const newDepartment = role.department;
            const newTeam = role.team;

            const department = this.department;
            if (!department && newDepartment) {
                return false;
            }
            if (!newDepartment && department) {
                return false;
            }
            if (department && newDepartment && department.id !== newDepartment.id) {
                return false;
            }

            const team = this.team;
            if (!team && newTeam) {
                return false;
            }
            if (!newTeam && team) {
                return false;
            }
            if (team && newTeam && team.id !== newTeam.id) {
                return false;
            }

            if (!this.from && !this.to || !role.from && !role.to) {
                return true;
            }

            if (role.from !== null && this.from === null && (this.to === null || role.getFromMomentObject() <= this.getToMomentObject())) {
                return true;
            }
            if (this.from !== null && role.from === null && (role.to === null || this.getFromMomentObject() <= role.getToMomentObject())) {
                return true;
            }

            if (role.from && this.from && this.to && role.getFromMomentObject() <= this.getToMomentObject() && (!role.to || this.getToMomentObject() <= role.getToMomentObject())) {
                return true;
            }

            if (role.from && this.to && role.to && this.getToMomentObject() < role.getFromMomentObject() && (!this.to || role.getFromMomentObject() <= this.getToMomentObject())) {
                return true;
            }

            if (this.to && role.to && role.from && this.getToMomentObject() <= role.getToMomentObject() && role.getFromMomentObject() <= this.getToMomentObject()) {
                return true;
            }

            if (role.to && this.to && this.from && role.getToMomentObject() <= this.getToMomentObject() && this.getFromMomentObject() <= role.getToMomentObject()) {
                return true;
            }
        }
        return false;
    }
}
